import React, { useState } from 'react';
import axios from 'axios';

export default function HrManagement() {
  const [profileName, setProfileName] = useState('');
  const [profileCode, setProfileCode] = useState('');
  
  const [deptName, setDeptName] = useState('');
  const [deptType, setDeptType] = useState('Department');

  const [posTitle, setPosTitle] = useState('');
  const [posCode, setPosCode] = useState('');
  const [posLevel, setPosLevel] = useState('Staff');
  const [posDeptId, setPosDeptId] = useState('');
  
  const [message, setMessage] = useState('');

  const handleCreateProfile = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post('http://localhost:8000/api/hr/profiles', {
        company_id: 1,
        name: profileName,
        code: profileCode,
      });
      setMessage('Profile created successfully with ID: ' + response.data.profile.id);
      setProfileName('');
      setProfileCode('');
    } catch (error) {
      setMessage('Error creating profile: ' + (error.response?.data?.message || error.message));
    }
  };

  const handleCreateDepartment = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post('http://localhost:8000/api/hr/departments', {
        company_id: 1,
        name: deptName,
        unit_type: deptType,
      });
      setMessage('Department created successfully! Code generated: ' + response.data.department.code);
      setDeptName('');
    } catch (error) {
      setMessage('Error creating department: ' + (error.response?.data?.message || error.message));
    }
  };

  const handleCreatePosition = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post('http://localhost:8000/api/hr/positions', {
        company_id: 1,
        department_id: posDeptId,
        title: posTitle,
        code: posCode,
        level: posLevel,
      });
      setMessage('Position created successfully with ID: ' + response.data.position.id);
      setPosTitle('');
      setPosCode('');
      setPosDeptId('');
    } catch (error) {
      setMessage('Error creating position: ' + (error.response?.data?.message || error.message));
    }
  };

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h2>HR Management - Submodules 1 & 2</h2>
      
      {message && <div style={{ padding: '10px', background: '#e2f0d9', marginBottom: '15px' }}>{message}</div>}

      <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
        {/* Profile Form */}
        <div style={{ border: '1px solid #ccc', padding: '20px', width: '320px', borderRadius: '5px' }}>
          <h3>Create HR Profile</h3>
          <form onSubmit={handleCreateProfile}>
            <div style={{ marginBottom: '10px' }}>
              <label>Profile Name:</label><br />
              <input 
                type="text" 
                value={profileName} 
                onChange={(e) => setProfileName(e.target.value)} 
                required 
                style={{ width: '100%', padding: '8px' }}
              />
            </div>
            <div style={{ marginBottom: '10px' }}>
              <label>Profile Code:</label><br />
              <input 
                type="text" 
                value={profileCode} 
                onChange={(e) => setProfileCode(e.target.value)} 
                required 
                style={{ width: '100%', padding: '8px' }}
              />
            </div>
            <button type="submit" style={{ padding: '10px 15px', background: '#007bff', color: '#fff', border: 'none', cursor: 'pointer' }}>
              Save Profile
            </button>
          </form>
        </div>

        {/* Department Form */}
        <div style={{ border: '1px solid #ccc', padding: '20px', width: '320px', borderRadius: '5px' }}>
          <h3>Create Department</h3>
          <form onSubmit={handleCreateDepartment}>
            <div style={{ marginBottom: '10px' }}>
              <label>Department Name:</label><br />
              <input 
                type="text" 
                value={deptName} 
                onChange={(e) => setDeptName(e.target.value)} 
                required 
                style={{ width: '100%', padding: '8px' }}
              />
            </div>
            <div style={{ marginBottom: '10px' }}>
              <label>Unit Type:</label><br />
              <select 
                value={deptType} 
                onChange={(e) => setDeptType(e.target.value)} 
                style={{ width: '100%', padding: '8px' }}
              >
                <option value="Department">Department</option>
                <option value="Division">Division</option>
                <option value="Section">Section</option>
                <option value="Unit">Unit</option>
              </select>
            </div>
            <button type="submit" style={{ padding: '10px 15px', background: '#28a745', color: '#fff', border: 'none', cursor: 'pointer' }}>
              Save Department
            </button>
          </form>
        </div>

        {/* Position Form */}
        <div style={{ border: '1px solid #ccc', padding: '20px', width: '320px', borderRadius: '5px' }}>
          <h3>Create Position</h3>
          <form onSubmit={handleCreatePosition}>
            <div style={{ marginBottom: '10px' }}>
              <label>Department ID:</label><br />
              <input 
                type="number" 
                value={posDeptId} 
                onChange={(e) => setPosDeptId(e.target.value)} 
                required 
                style={{ width: '100%', padding: '8px' }}
              />
            </div>
            <div style={{ marginBottom: '10px' }}>
              <label>Position Title:</label><br />
              <input 
                type="text" 
                value={posTitle} 
                onChange={(e) => setPosTitle(e.target.value)} 
                required 
                style={{ width: '100%', padding: '8px' }}
              />
            </div>
            <div style={{ marginBottom: '10px' }}>
              <label>Position Code:</label><br />
              <input 
                type="text" 
                value= {posCode} 
                onChange={(e) => setPosCode(e.target.value)} 
                required 
                style={{ width: '100%', padding: '8px' }}
              />
            </div>
            <div style={{ marginBottom: '10px' }}>
              <label>Level:</label><br />
              <select 
                value={posLevel} 
                onChange={(e) => setPosLevel(e.target.value)} 
                style={{ width: '100%', padding: '8px' }}
              >
                <option value="Staff">Staff</option>
                <option value="Supervisor">Supervisor</option>
                <option value="Manager">Manager</option>
                <option value="Director">Director</option>
              </select>
            </div>
            <button type="submit" style={{ padding: '10px 15px', background: '#ffc107', color: '#000', border: 'none', cursor: 'pointer', fontWeight: 'bold' }}>
              Save Position
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}